import { render, staticRenderFns } from "./PromotionIcreas.vue?vue&type=template&id=284a4ad8&"
import script from "./PromotionIcreas.vue?vue&type=script&lang=js&"
export * from "./PromotionIcreas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports